import { useState, type FormEvent } from 'react'
import { useAuthStore } from '../store/authStore'
import { useTheme } from '../hooks/useTheme'

const SIM_API = import.meta.env.VITE_SIM_API_URL || 'http://localhost:8001'

export default function LoginPage() {
  const C = useTheme()
  const login = useAuthStore((s) => s.login)

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState<string | null>(null)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const res = await fetch(`${SIM_API}/api/v1/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      })
      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.detail ?? `Error ${res.status}`)
      }
      const data = await res.json()
      login(data.access_token, data.user)
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Error de conexión')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: `linear-gradient(135deg, #0a1220 0%, ${C.primary} 50%, #0a1220 100%)`,
      fontFamily: "'Open Sans', system-ui, sans-serif",
    }}>
      {/* Card */}
      <div style={{
        background: C.card, border: `1px solid ${C.border}`,
        borderRadius: 16, padding: '40px 44px', width: 360,
        boxShadow: '0 24px 64px rgba(0,0,0,0.45)',
      }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            display: 'inline-block',
            background: '#F89421', borderRadius: 8,
            padding: '6px 14px',
            fontWeight: 800, fontSize: 18, color: '#4a2a07',
            letterSpacing: 1, marginBottom: 12,
          }}>
            ATMVISION
          </div>
          <div style={{ fontWeight: 600, fontSize: 15, color: C.text, marginBottom: 2 }}>
            Banreservas · NOC
          </div>
          <div style={{ fontSize: 11, color: C.muted }}>
            Red de 933 Cajeros Automáticos
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Error */}
          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)',
              borderRadius: 8, padding: '10px 14px',
              fontSize: 12, color: '#ef4444', textAlign: 'center',
            }}>
              {error}
            </div>
          )}

          {/* Username */}
          <div>
            <label style={{ fontSize: 11, color: C.muted, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Usuario
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              placeholder="Ej. admin"
              style={{
                width: '100%', boxSizing: 'border-box',
                background: C.card2, color: C.text,
                border: `1px solid ${C.border}`,
                borderRadius: 8, padding: '10px 12px',
                fontSize: 13, fontFamily: 'inherit', outline: 'none',
              }}
              onFocus={(e) => (e.currentTarget.style.borderColor = '#02AFF0')}
              onBlur={(e)  => (e.currentTarget.style.borderColor = C.border)}
            />
          </div>

          {/* Password */}
          <div>
            <label style={{ fontSize: 11, color: C.muted, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              placeholder="••••••••"
              style={{
                width: '100%', boxSizing: 'border-box',
                background: C.card2, color: C.text,
                border: `1px solid ${C.border}`,
                borderRadius: 8, padding: '10px 12px',
                fontSize: 13, fontFamily: 'inherit', outline: 'none',
              }}
              onFocus={(e) => (e.currentTarget.style.borderColor = '#02AFF0')}
              onBlur={(e)  => (e.currentTarget.style.borderColor = C.border)}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading ? 'rgba(2,175,240,0.5)' : '#02AFF0',
              color: '#fff', border: 'none', borderRadius: 8,
              padding: '11px 0', fontSize: 14, fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit', marginTop: 4,
              transition: 'background 0.15s',
            }}
          >
            {loading ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>

        {/* Footer */}
        <div style={{ marginTop: 28, textAlign: 'center', fontSize: 10, color: C.muted }}>
          ATMVISION v0.1 · Laboratorio de Ingeniería · VP Arquitectura TI
        </div>
      </div>
    </div>
  )
}
